import api from '~/api';
import { VerifyDirectLoginResponse } from '../dtos/verifyDirectLoginResponse';
import { User } from '../models/user.model';

export async function verifyDirectLogin(hourlyToken: string): Promise<User> {
  const { data } = await api.post<VerifyDirectLoginResponse>(`/v6/session/verify/hidden_user`, {
    token: hourlyToken,
  });

  return {
    id: data.user_id,
    firstName: data.user_first_name,
    lastName: data.user_last_name,
    profilePhoto: data.user_profile_photo_id,
  };
}
